import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaymentProviderPayMethodViewModel } from 'libs/core/src/lib/model/view-model/payment-provider-pay-method.view.model';
import { PaymentProviderStateService } from '../../../service/payment-provider-state.service';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  standalone: false
})
export class PaymentMethodComponent implements OnInit {
  @Input() public paymentMethod: PaymentProviderPayMethodViewModel;
  @Input() public paymentType: string;
  @Input() public paymentProvider: string;
  @Input() public paymentImgUrl: string;
  @Input() public customLabel: string | null = null;

  @Input() public followup: boolean = false;

  @Input()
  public set selected(value: boolean) {
    this._selected = value;
  }

  @Output() public onPaymentProviderClick = new EventEmitter<Event>();

  private _selected = false;

  constructor(
    private translateService: TranslateService,
    private paymentProviderStateService: PaymentProviderStateService
  ) {}

  ngOnInit() {}

  public paymentProviderClick(event: Event) {
    const model = this.paymentProviderStateService.getState();
    this.paymentProviderStateService.setState({ ...model, type: this.paymentType, provider: this.paymentProvider });
    this.onPaymentProviderClick.emit(event);

    if (this.followup) {
      setTimeout(() => {
        this.scrollToElement(event.target as HTMLElement);
      }, 100);
    }
  }

  get properTranslation() {
    if (this.customLabel) {
      return this.customLabel;
    }

    if (this.paymentMethod && this.paymentMethod.id.toLocaleLowerCase() === 'jp') {
      return this.translateService.instant('payment.method.applePay');
    }
    return this.translateService.instant('payment.method.' + this.paymentType);
  }

  public get selected() {
    return this._selected;
  }

  private scrollToElement(element: HTMLElement) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
